module.exports = "<span class=\"text text__small text__alef text__secondary\">{{ text }}</span>\r\n\r\n<i class=\"arrow-down\"></i>"